import {Pipe, PipeTransform} from '@angular/core';
import {TypeElement} from 'app/shared/model/type-element';

@Pipe({name: 'typeElement'})
export class TypeElementPipe implements PipeTransform {

    transform(value: TypeElement | 'ALERTABLE'): string {
        switch (value) {
            case 'PARC':
                return 'Parc';
            case 'SECTEUR':
                return 'Secteur';
            case 'RESIDENCE':
                return 'Ensemble';
            case 'BATIMENT':
                return 'Bâtiment';
            case 'LOT':
                return 'Zone';
            case 'PIECE':
                return 'Pièce';
            case 'OUVRAGE':
                return 'Ouvrage';
            case 'PIECE2':
                return 'Pièce';
            case 'ALERTABLE':
                return 'Alerte';

        }
    }

}
